import { SwitchItem } from "./Switch";

interface Props {
  label: SwitchItem<string>["label"];
}

export default function SwitchLabel({ label }: Props) {
  if (!label) {
    return null;
  }

  if (typeof label === "string") {
    return <span>{label}</span>;
  }

  return (
    <>
      <span className="hidden md:inline">{label.desktop}</span>
      <span className="md:hidden">{label.mobile}</span>
    </>
  );
}
